import { createContext, useContext } from 'react';

/**
 * セルフサインアップが開いているか。
 *
 * 開閉はサーバーの env (`SIGNUP_ENABLED`) が決める。画面側は起動時に
 * `GET /api/signup` を 1 度だけ叩き (`main.tsx`)、その結果をここで配る。
 * 200 なら開いている / 404 なら経路ごと無い、という判別で、
 * `/api/auth/me` の 404 で運営ホストを見分けているのと同じ形。
 *
 * **既定は閉。** 未設定なら閉じている、というサーバー側の既定に画面も揃える
 * (問い合わせに失敗したときに申し込み導線を出さない)。
 *
 * prop で配らないのは、申し込み導線を持つ画面がログイン状態を知らない場所にも
 * あるため。`SiteFooter` は法務ページ (`LegalLayout`) からも出る。
 */
export const SignupOpenContext = createContext(false);

export function useSignupOpen(): boolean {
  return useContext(SignupOpenContext);
}
